import { render, staticRenderFns } from "./ImaginaryUpgradesTab.vue?vue&type=template&id=36673861&scoped=true"
import script from "./ImaginaryUpgradesTab.vue?vue&type=script&lang=js"
export * from "./ImaginaryUpgradesTab.vue?vue&type=script&lang=js"
import style0 from "./ImaginaryUpgradesTab.vue?vue&type=style&index=0&id=36673861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36673861",
  null
  
)

export default component.exports